import { call, put, takeEvery, all, fork } from "redux-saga/effects";
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import {
  GET_ACCSETTING,
  DELETE_ACCSETTING,
  UPDATE_ACCSETTING,
  ADD_NEW_ACCSETTING,
} from "./actionType";

import {
  getAccSettingSuccess,
  getAccSettingFail,
  deleteAccSettingSuccess,
  deleteAccSettingFail,
  updateAccSettingSuccess,
  updateAccSettingFail,
  addAccSettingSuccess,
  addAccSettingFail,
} from "./action";

//Include Both Helper File with needed methods
import {
  approveAccSettingApi,
  getAccSettingApi,
  updateAccSettingApi,
  deleteAccSettingApi,
  addNewAccSettingApi
} from "../../helpers/backend_helper";

function* getAccSetting({ payload: accSetting }) {
  try {
    const response = yield call(getAccSettingApi, accSetting);
    yield put(getAccSettingSuccess(GET_ACCSETTING, response.data));
  } catch (error) {
    yield put(getAccSettingFail(GET_ACCSETTING, error));
  }
}

function* onUpdateAccSetting({ payload: accSetting }) {
  try {
    if (accSetting.setApprove) {
      const response = yield call(approveAccSettingApi, accSetting);
      yield put(updateAccSettingSuccess(response));
      toast.success(response.message, { position: "bottom-left", autoClose: 3000 });
    }
    else {
      const response = yield call(updateAccSettingApi, accSetting);
      yield put(updateAccSettingSuccess(response));
      toast.success(response.message, { position: "bottom-left", autoClose: 3000 });
    }
  } catch (error) {
    yield put(updateAccSettingFail(error));
    toast.error(error.response.data.message, { position: "bottom-left", autoClose: 3000 });
  }
}

function* onDeleteAccSetting({ payload: accSetting }) {
  try {
    const response = yield call(deleteAccSettingApi, accSetting);
    yield put(deleteAccSettingSuccess({ accSetting, ...response }));
    toast.success(response.message, { position: "bottom-left", autoClose: 3000 });
  } catch (error) {
    yield put(deleteAccSettingFail(error));
    toast.error(error.response.data.message, { position: "bottom-left", autoClose: 3000 });
  }
}

function* onAddNewAccSetting({ payload: accSetting }) {
  try {
    const response = yield call(addNewAccSettingApi, accSetting);
    yield put(addAccSettingSuccess(response));
    toast.success(response.message, { position: "bottom-left", autoClose: 3000 });
  } catch (error) {
    yield put(addAccSettingFail(error));
    toast.error(error.response.data.message, { position: "bottom-left", autoClose: 3000 });
  }

}

export function* watchGetAccSetting() {
  yield takeEvery(GET_ACCSETTING, getAccSetting);
}

export function* watchUpdateAccSetting() {
  yield takeEvery(UPDATE_ACCSETTING, onUpdateAccSetting);
}

export function* watchDeleteAccSetting() {
  yield takeEvery(DELETE_ACCSETTING, onDeleteAccSetting);
}

export function* watchAddNewAccSetting() {
  yield takeEvery(ADD_NEW_ACCSETTING, onAddNewAccSetting);
}

function* accSettingSaga() {
  yield all([
    fork(watchGetAccSetting),
    fork(watchDeleteAccSetting),
    fork(watchUpdateAccSetting),
    fork(watchAddNewAccSetting)
  ]);
}

export default accSettingSaga;
